let hasShoppable = document.querySelector('[data-section-options="shoppable"]');
if (hasShoppable) {
  let shopItems = document.querySelectorAll('.featured-item-dot');
  let shopPanels = document.querySelectorAll('.featured-item-panel');
  let closeIcons = document.querySelectorAll('.close-icon');
  let panelUnderlay = document.querySelector('.panel-underlay');

  function updateVariant(target) {
    let variantOptionGroup = target.closest('.ColorSwatchList');
    let panel = variantOptionGroup.closest('.featured-item-panel');
    let variantSelectors = variantOptionGroup.querySelectorAll('.ColorSwatch');
    variantSelectors.forEach(option => {
      let parent = option.closest('.HorizontalList__Item');
      let radio = parent.querySelector('.ColorSwatch__Radio');
      radio.removeAttribute('checked')
      radio.parentElement.querySelector('label').removeAttribute('data-input-checked')
    });
    let selectedParent = target.closest('.HorizontalList__Item');
    let radio = selectedParent.querySelector('.ColorSwatch__Radio');
    radio.setAttribute('checked','checked')
    radio.parentElement.querySelector('label').setAttribute('data-input-checked','checked')
    // let radioValue = this.textContent.toLowerCase();
    let radioValue = target.dataset.value.toLowerCase();
    target.closest('.ColorSwatchList').closest('.ProductForm__Option').querySelector('.ProductForm__SelectedValue').textContent = target.dataset.value;
    let imageQuery = 'img[data-item-color="' + radioValue + '"]';
    let panelImages = panel.querySelectorAll('img');
    let selectedImage = panel.querySelector(imageQuery);
    if (selectedImage) {
      panelImages.forEach(image => {
        image.classList.add('hidden')
      })
      selectedImage.classList.remove('hidden'); 
    }
    let selectedOptions = panel.querySelectorAll('input[type="radio"]:checked');
    let selectedValues = [];
    selectedOptions.forEach(selection => {
      selectedValues.push(selection.value);
    });
    let compareIndex = selectedValues.length - 1;
    let lookupValue = '';
    for (let i = 0; i < selectedValues.length; i++) {
      lookupValue += selectedValues[i];
      if (i !== compareIndex) {
        lookupValue += ' / ';
      }
    }
    if (lookupValue) {
      let selectInput = panel.querySelector('select');
      let selectOptions = selectInput.querySelectorAll('option');
      selectOptions.forEach(selectOption => {
        selectOption.removeAttribute('selected');
        let optionText = selectOption.textContent;
        let optionSplit = optionText.split(' - ');
        let optionCompare = optionSplit[0];
        if (optionCompare === lookupValue) {
          selectOption.setAttribute('selected', 'selected');
          return
        }
      })
    }
  }

  function mountForm(displayPanel) {
    let variantSelectors = displayPanel.querySelectorAll('.ColorSwatch');
    variantSelectors.forEach(option => {
      option.addEventListener('click', (e) => {
        updateVariant(e.currentTarget);
        checkColor(option.dataset.value.toLowerCase(), displayPanel)
        // checkAvailableSizeVariants(displayPanel)
      })
    })
  }

  function displayUnderlay() {
    panelUnderlay.classList.add('panel-transition-in');
    panelUnderlay.classList.add('panel-visible');
    setTimeout(function() {
      panelUnderlay.classList.remove('panel-transition-in');
    }, 200)
  }

  function hideUnderlay() {
    panelUnderlay.classList.add('panel-transition-out');
    panelUnderlay.classList.remove('panel-visible');
    setTimeout(function() {
      panelUnderlay.classList.remove('panel-transition-out');
    }, 200)
  }

  function checkColor(itemColor, displayPanel) {
    if (itemColor) {
      let options = displayPanel.querySelectorAll('.ColorSwatch');
      options.forEach(option => {
          // let optionValue = option.textContent.toLowerCase();
        let optionValue = option.dataset.value.toLowerCase()
          if (optionValue === itemColor) {
              option.click();
            removeAllchecked(displayPanel)
            option.closest('.ColorSwatchList').closest('.ProductForm__Option').querySelector('.ProductForm__SelectedValue').textContent = option.dataset.value;
            option.closest('.HorizontalList__Item').querySelector('input[type="radio"]').setAttribute('checked','checked')
            option.closest('.HorizontalList__Item').querySelector('label').setAttribute('data-input-checked','checked')
            checkAvailableSizeVariants(displayPanel)
              let imageQuery = 'img[data-item-color="' + optionValue + '"]';
              let panelImages = displayPanel.querySelectorAll('img');
              let selectedImage = displayPanel.querySelector(imageQuery);
              if (selectedImage) {
                panelImages.forEach(image => {
                  image.classList.add('hidden')
                })
                selectedImage.classList.remove('hidden'); 
              }
              return
          }
      })
    }
  }

  function checkAvailableSizeVariants(displayPanel){
     let id = displayPanel.dataset.itemId;
    if(document.querySelectorAll('.featured-item-panel[data-item-id="' + id + '"] ul.HorizontalList--spacingTight[data-option-index="1"] label').length){
  var cValue = document.querySelector('.featured-item-panel[data-item-id="' + id + '"] .HorizontalList__Item [name="option-0"][checked="checked"]').value;
  document.querySelectorAll('.featured-item-panel[data-item-id="' + id + '"] ul.HorizontalList--spacingTight[data-option-index="1"] label').forEach(function(ele){
    ele.classList.add('is-disabled');
  });
    const avlOptions =  document.querySelectorAll('.featured-item-panel[data-item-id="' + id + '"] select.get-var option[available]')
  avlOptions.forEach(function(ele){
    var value = ele.value;
    var setVal = value.split(' / ')[0];
    if(setVal == cValue){
      var avlValue = value.split(' / ')[1];
      document.querySelector('.featured-item-panel[data-item-id="' + id + '"] ul.HorizontalList--spacingTight[data-option-index="1"] label[data-value="'+avlValue+'"]').classList.remove('is-disabled');
    }
  });
}
  }


  function closeItemPane() {
    hideUnderlay();
    shopPanels.forEach(panel => {
      panel.classList.remove('panel-show')
    });
  }

  function removeAllchecked(displayPanel){
  let id = displayPanel.dataset.itemId;
    document.querySelectorAll('.featured-item-panel[data-item-id="' + id + '"] .ColorSwatchList input').forEach(input => {
      input.removeAttribute('checked')
    })
    document.querySelectorAll('.featured-item-panel[data-item-id="' + id + '"] .ColorSwatchList label').forEach(label => {
      label.removeAttribute('data-input-checked')
    })
  }

  function showItemPane() {
    let itemId = this.getAttribute('data-item-id');
    let itemColor = this.getAttribute('data-item-color');
    closeItemPane();
    let panelQuery = '.featured-item-panel[data-item-id="' + itemId + '"]';
    let displayPanel = document.querySelector(panelQuery);
     // removeAllchecked(displayPanel)
    checkColor(itemColor, displayPanel);
    displayUnderlay();
    displayPanel.classList.add('panel-show');
    mountForm(displayPanel);
  }

  shopItems.forEach(item => {
    item.addEventListener('click', showItemPane)
  })

  closeIcons.forEach(icon => {
    icon.addEventListener('click', closeItemPane);
  })

  panelUnderlay.addEventListener('click', closeItemPane);

  // function getSelectedVariant() {
  //   setTimeout(function() {
  //     let stockNotifyBtn = document.getElementById("BIS_trigger");
  //     let selectedVariant = document.querySelectorAll('.variant-option');

  //     for (let i = 0; i < selectedVariant.length; i++) {
  //       let optionItem = selectedVariant[i];
  //       let currentSelection = optionItem.selected;
  //       let optionId = optionItem.value;
  //       let optionAvailable = optionItem.getAttribute('available');

  //       if (currentSelection && optionAvailable === "false") {
  //         console.log("unavailable: " + optionId );
  //         stockNotifyBtn.classList.add("show");
  //         stockNotifyBtn.classList.remove("noshow");
  //         return
  //       } else if (currentSelection && optionAvailable === "true") {
  //         console.log("available: " + optionId );
  //         stockNotifyBtn.classList.add("noshow");
  //         stockNotifyBtn.classList.remove("show");
  //       }
  //     }
  //   }, 10);
  // }

  // getSelectedVariant();
  
}


